import styled from 'styled-components';

import brandConfig from '../config/brand';
import { BurgerIcon } from '../assets/icons/burger';
import { Link } from 'react-router-dom';

export type TopNavProps = {
  onToggle: () => void;
};

export const TopNav = ({ onToggle }: TopNavProps) => {
  return (
    <Container>
      <Link to="/dashboard">
        <Logo src={brandConfig.logo} alt={`${brandConfig.displayName} logo`} />
      </Link>

      <button onClick={onToggle}>
        <BurgerIcon size={30} />
      </button>
    </Container>
  );
};

const Logo = styled.img`
  width: 3rem;
`;

const Container = styled.div`
  display: none;
  padding: 0.5rem 1rem;
  background-color: ${({ theme }) => theme.colors.gray};
  justify-content: space-between;

  @media (max-width: 850px) {
    display: flex;
  }
`;
